import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../../../../services/partner.service';
import { HelpersService } from '../../../../services/helpers.service';
import { BroadcastService } from '../../../../services/broadcast.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-external-redirect',
  templateUrl: './external-redirect.component.html',
  styleUrls: ['./external-redirect.component.scss'],
})
export class ExternalRedirectComponent implements OnInit {
  constructor(
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    public route: ActivatedRoute,
    public router: Router,
    private broadcastService: BroadcastService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      let accountID = params['accountID'];
      let shopID = params['shopID'];
      let saleID = params['saleID'];
      let serviceID = params['ServiceID'];
      if(!serviceID || serviceID === null) {
        serviceID = params['serviceID'];
      }
      let partnerMessageID = params['PartnerMessageID'];
      let type = params['type'];
      let vendSaleID = params['vendSaleID'];
      let view = params['view'];
      if (type === 'sale') {
        this.redirectLightspeedSale(accountID, shopID, saleID);
      } else if (vendSaleID && vendSaleID !== null) {
        this.redirectVendSale(vendSaleID);
      } else if (serviceID && serviceID > 0) {
        this.redirectService(serviceID, partnerMessageID, view);
      }
    });
  }

  redirectLightspeedSale(accountID, shopID, saleID) {
    this.partnerService
      .getLightspeedRedirectInfo(accountID, shopID, saleID)
      .subscribe((result) => {
        if (result.partnerID === this.helpersService.getPartnerId()) {
          this.helpersService.setActiveProduct(null);
          this.helpersService.setLastURL(null);
          this.router.navigateByUrl(
            '/store/calendar?ServiceID=' + result.serviceID,
          );
        } else {
          this.helpersService.setActiveProduct(null);
          this.helpersService.setLastURL(null);
          this.helpersService.saveProductData([]);
          var profile = this.helpersService.getProfileData();
          profile.PartnerID = result.partnerID;
          this.helpersService.saveProfileData(profile);
          this.broadcastService.sendMessage({
            partner: { switchPartner: true },
          });
          setTimeout(() => {
            this.router.navigateByUrl(
              '/store/calendar?ServiceID=' + result.serviceID,
            );
          });
        }
      });
  }

  redirectVendSale(vendSaleID) {
    this.partnerService.getVendRedirectInfo(vendSaleID).subscribe((result) => {
      if (result.partnerID === this.helpersService.getPartnerId()) {
        this.router.navigateByUrl(
          '/store/calendar?ServiceID=' + result.serviceID,
        );
      } else {
        this.helpersService.saveProductData([]);
        var profile = this.helpersService.getProfileData();
        profile.PartnerID = result.partnerID;
        this.helpersService.saveProfileData(profile);
        this.broadcastService.sendMessage({ partner: { switchPartner: true } });
        setTimeout(() => {
          this.router.navigateByUrl(
            '/store/calendar?ServiceID=' + result.serviceID,
          );
        });
      }
    });
  }

  redirectService(serviceID, partnerMessageID, view) {
    this.partnerService
      .getServiceRedirectInfo(serviceID)
      .subscribe((result) => {
        if (result.partnerID === this.helpersService.getPartnerId()) {
          this.router.navigateByUrl(
            '/store/calendar?ServiceID=' +
              result.serviceID +
              (partnerMessageID ? '&PartnerMessageID=' + partnerMessageID : '') + 
              (view ? '&view=' + view : ''),
          );
        } else {
          this.helpersService.setActiveProduct(null);
          this.helpersService.setLastURL(null);
          this.helpersService.saveProductData([]);
          var profile = this.helpersService.getProfileData();
          profile.PartnerID = result.partnerID;
          this.helpersService.saveProfileData(profile);
          this.broadcastService.sendMessage({
            partner: { switchPartner: true },
          });
          setTimeout(() => {
            this.router.navigateByUrl(
              '/store/calendar?ServiceID=' +
                result.serviceID +
                (partnerMessageID ? '&PartnerMessageID=' + partnerMessageID : '') +
                (view ? '&view=' + view : ''),
            );
          });
        }
      },error => {
        console.log('Error fetching service redirect info:', error);
        // Optionally, navigate to an error page or show a message to the user
         this.router.navigateByUrl('/store/calendar');
      });
  }
}
